var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav_breadcrumbs"},[_c('li',[_c('router-link',{attrs:{"to":"/modules/home"}},[_vm._v(_vm._s(_vm.lang.LBL_HOME))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }